import styled from 'styled-components';
import {dFlexColumn} from '../../../../../globalVariables/GlobalFlex';

export const wrap = styled.div`
    ${dFlexColumn};
    gap: var(--space-xs);

    &.disabled {
        opacity: 0.45;
        cursor: not-allowed;

        & > * {
            pointer-events: none;
        }
    }
`;

export const errorText = styled.span`
    color: var(--color-state-error-main);
    font-size: var(--font-size-caption);
`;
